import React from "react";

/**
 * 프론트 IP 가림막.
 *
 * 맥미니(Docker Desktop) 환경에서는 NAT 때문에 nginx·백엔드가 실제 클라이언트
 * IP를 볼 수 없어서(모두 192.168.65.1), 프론트가 외부 조회 서비스로 자신의
 * 공인 IP를 확인해 허용 목록 외 접속이면 화면을 띄우지 않는다.
 *
 * ⚠️ 이 방식은 "가림막"이지 보안 수단이 아니다 — 실질 보호는 관리자 로그인이 담당한다.
 */

// 접속을 허용할 공인 IP 목록
const ALLOWED_IPS = ["121.138.149.60", "121.138.149.61", "211.107.166.53"];

// 공인 IP 조회 서비스 (앞이 실패하면 순서대로 폴백)
const IP_ECHO_SERVICES = [
    { url: "https://api.ipify.org?format=json", pick: (d) => d.ip },
    { url: "https://ipinfo.io/json", pick: (d) => d.ip },
    { url: "https://api.ip.pe.kr/json/", pick: (d) => d.ip },
];

async function fetchPublicIp() {
    for (const svc of IP_ECHO_SERVICES) {
        try {
            const res = await fetch(svc.url, { cache: "no-store" });
            if (!res.ok) continue;
            const data = await res.json();
            const ip = svc.pick(data);
            if (ip) return String(ip).trim();
        } catch (e) {
            // 다음 서비스로 폴백
        }
    }
    return null;
}

/** 허용 여부 확인. { allowed, ip } 반환 — ip 조회 실패 시 allowed=false, ip=null */
export async function checkIpAllowed() {
    const ip = await fetchPublicIp();
    return { allowed: ip !== null && ALLOWED_IPS.indexOf(ip) !== -1, ip };
}

/** 차단 안내 화면 — 허용 목록 외 IP 또는 IP 확인 실패 시 표시 */
export function BlockedScreen({ ip }) {
    const wrap = {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f4f6f9",
        fontFamily: "-apple-system, 'Malgun Gothic', sans-serif",
        color: "#333",
        padding: 24,
        textAlign: "center",
    };
    return (
        <div style={wrap}>
            <div style={{ fontSize: 44, marginBottom: 12 }}>&#128683;</div>
            <h1 style={{ fontSize: 22, margin: "0 0 8px" }}>접속이 제한된 페이지입니다</h1>
            <p style={{ fontSize: 15, color: "#666", margin: "0 0 4px" }}>
                허용된 네트워크에서만 이용할 수 있습니다.
            </p>
            <p style={{ fontSize: 13, color: "#999", margin: "0 0 20px" }}>
                {ip ? `현재 접속 IP: ${ip}` : "접속 IP를 확인하지 못했습니다 (네트워크 상태를 확인해 주세요)"}
            </p>
            <button
                type="button"
                onClick={() => window.location.reload()}
                style={{
                    padding: "10px 28px",
                    fontSize: 14,
                    border: "1px solid #ccc",
                    borderRadius: 6,
                    background: "#fff",
                    cursor: "pointer",
                }}
            >
                다시 확인
            </button>
        </div>
    );
}
